/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreOrderPrediction
 */
export interface StoreOrderPrediction {
    /**
     * Whether automatic order prediction is enabled for this store.
     * @type {boolean}
     * @memberof StoreOrderPrediction
     */
    enabled: boolean;
    /**
     * The algorithm used for order prediction when enabled.
     * @type {string}
     * @memberof StoreOrderPrediction
     */
    algorithm?: string;
}

/**
 * Check if a given object implements the StoreOrderPrediction interface.
 */
// @ts-ignore
export function instanceOfStoreOrderPrediction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

// @ts-ignore
export function StoreOrderPredictionFromJSON(json: any): StoreOrderPrediction {
    return StoreOrderPredictionFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreOrderPredictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreOrderPrediction {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'algorithm': !exists(json, 'algorithm') ? undefined : json['algorithm'],
    };
}

// @ts-ignore
export function StoreOrderPredictionToJSON(value?: StoreOrderPrediction | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'algorithm': value.algorithm,
    };
}

